import React, { useState } from "react";
import  heroBarnd from '../../assets/neet/bipc2.png'
import { AboutSection } from "../courses/commoncomponents";
// Rankridge BIPC + NEET Landing Page (Responsive + Attractive)
// TailwindCSS required. Drop into your React app and use <RankridgeBIPCNEETPage />
// Replace placeholder images/logos with your assets.
import { bipcwithneet, homeImages, neetRankImages } from "../data";


const aboutTitle='About Rankridge BIPC with NEET Coaching'
const aboutDescription=`Rankridge Junior College is Hyderabad’s most trusted destination for BIPC with NEET coaching, designed for students aspiring to secure top ranks in medical entrance exams. With expert faculty drawn from AIIMS, reputed NEET academies, and senior lecturers with decades of experience, we ensure every student masters NCERT fundamentals and develops exam-ready confidence.
Our track record speaks for itself — 99% of our students qualify NEET annually, with many securing All India Top Ranks and admissions into AIIMS, JIPMER, Gandhi Medical College, Osmania, and KMC. Students benefit from small batch sizes, interactive doubt-solving, and high-quality NEET study modules prepared by experts for maximum results.
` 
const description2='' 
 


export default function RankridgeBIPCNEETPage() {
  return (
    <main className="bg-neutral-50 text-neutral-900">
      <HeroSection />
<AboutSection title={aboutTitle} description={aboutDescription} description2={description2} imagePath={bipcwithneet[0]}   />
      <TrustBar />
      <Highlights />
      <ValuePillars />
      <Stats />
      {/* <Showcase /> */}
      <FAQ />
      <ContactCTA />
      <Footer />
    </main>
  );
}

function HeroSection() {
  return (
    <section className="relative overflow-hidden">
      {/* Background decorations */}
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute -left-32 -top-32 h-80 w-80 rounded-full bg-teal-200/50 blur-3xl" />
        <div className="absolute -right-24 top-24 h-72 w-72 rounded-full bg-emerald-200/60 blur-3xl" />
        <div className="absolute left-1/3 top-1/2 h-64 w-64 -translate-y-1/2 rounded-full bg-cyan-100/80 blur-2xl" />
      </div>

      <div className="mx-auto max-w-7xl px-6 py-2 lg:flex lg:items-center lg:gap-12 lg:py-2">
        {/* Left content */}
        <div className="mx-auto max-w-2xl text-center sm:text-left">
          <span className="inline-flex items-center gap-2 rounded-full bg-teal-600/10 px-3 py-1 text-sm font-medium text-teal-700 ring-1 ring-inset ring-teal-600/20">
            Best BIPC College in Hyderabad with NEET Coaching
          </span>
          <h1 className="mt-5 text-4xl font-extrabold leading-tight tracking-tight sm:text-5xl">
            Where <span className="bg-gradient-to-r from-teal-600 to-emerald-600 bg-clip-text text-transparent">Medical Dreams Begin</span> with Confidence
          </h1>
          <p className="mt-5 text-lg leading-relaxed text-neutral-700">
            If your dream is to become a doctor, your journey starts at Rankridge Junior College—Hyderabad’s most trusted BIPC college with NEET coaching. We build confidence, clarity, and character with a result-driven system in a stress-free environment.
          </p>
          <div className="mt-7 flex flex-col items-center gap-3 sm:flex-row sm:justify-start">
            <a href="#admissions" className="inline-flex items-center justify-center rounded-2xl bg-teal-600 px-6 py-3 text-base font-semibold text-white shadow-md shadow-teal-600/20 transition hover:translate-y-[-1px] hover:bg-teal-700">
              Admissions Open 2025
            </a>
            <a href="#why" className="inline-flex items-center justify-center rounded-2xl bg-white px-6 py-3 text-base font-semibold text-teal-700 ring-1 ring-teal-600/20 transition hover:bg-teal-50">
              Why Rankridge?
            </a>
          </div>
          <p className="mt-3 text-sm text-neutral-500">Limited seats • Boys & Girls campuses • Day scholar & Residential</p>
        </div>

        {/* Right visual */}
        <div className="mx-auto mt-12 grid max-w-3xl grid-cols- gap-4 sm:gap-6 lg:mt-0">
         <img src={heroBarnd} className="rounded-2xl" />
         
          {/* <HeroCard title="NEET Focus" subtitle="NCERT Mastery • DPPs • PYQs" src="https://images.unsplash.com/photo-1585421514738-5133c6645c00?q=80&w=1200&auto=format&fit=crop"/>
          <HeroCard title="Stress‑free Study" subtitle="Yoga • Breaks • Mentors" src="https://images.unsplash.com/photo-1503676260728-1c00da094a0b?q=80&w=1200&auto=format&fit=crop"/>
          <HeroCard title="Top Results" subtitle="99% Qualify • AIR Ranks" src="https://images.unsplash.com/photo-1543269865-cbf427effbad?q=80&w=1200&auto=format&fit=crop"/>
          <HeroCard title="Premium Hostels" subtitle="24/7 Care • Hygienic Food" src="https://images.unsplash.com/photo-1526256262350-7da7584cf5eb?q=80&w=1200&auto=format&fit=crop"/> */} 
        </div>
      </div>
    </section>
  );
}

function HeroCard({ title, subtitle, src }) {
  return (
    <figure className="group overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-neutral-200">
      <img src={src} alt="Rankridge" className="aspect-[4/3] w-full object-cover transition duration-300 group-hover:scale-[1.03]"/>
      <figcaption className="p-4">
        <p className="text-sm font-semibold text-neutral-800">{title}</p>
        <p className="mt-1 text-xs text-neutral-500">{subtitle}</p>
      </figcaption>
    </figure>
  );
}

function TrustBar() {
  return (
    <div className="border-y  border-[#20b2aa] text-black backdrop-blur bg-[#20b2aa] rounded-2xl">
      <div className="mx-auto grid max-w-7xl grid-cols-2 items-center gap-6 px-6 py-6 sm:grid-cols-3 lg:grid-cols-6">
        {[
          "AIIMS",
          "JIPMER",
          "Gandhi MC",
          "Osmania",
          "KMC",
          "Top Govt. Colleges",
        ].map((t) => (
          <div key={t} className="text-center text-sm font-medium border-white text-black">{t}</div>
        ))}
      </div>
    </div>
  );
}

function Highlights() {
  const items = [
    {
      title: "Top‑Rated Faculty with NEET Expertise",
      points: [
        "Handpicked NEET experts, doctors & senior lecturers (15+ yrs).",
        "Interactive learning, NCERT mastery & AI‑based doubt analysis.",
        "Teachers who guide with patience, precision & passion.",
      ],
      quote: "Our teachers don’t just prepare for NEET, they live it.",
    },
    {
      title: "Proven Results. Proven System.",
      points: [
        "99% NEET qualification rate year after year.",
        "All India Top Ranks produced consistently.",
        "Weekly mock NEET, rank benchmarking & success roadmaps.",
      ],
    },
    {
      title: "Stress‑Free Learning with Small Batches",
      points: [
        "Only 40 students per class for personal attention.",
        "Daily doubt‑clearing & concept‑focused teaching.",
        "Relaxation breaks, yoga & wellness activities.",
      ],
      quote: "Learning should feel inspiring, not intimidating.",
    },
    {
      title: "India’s Best NEET Study Material",
      points: [
        "Scientifically designed Rankridge NEET modules.",
        "NCERT‑based notes, high‑yield concepts, DPPs & PYQs.",
        "Illustrations, quick‑revision cards & performance boosters.",
      ],
    },
    {
      title: "Premium Hostels & Hygienic Food",
      points: [
        "Separate hostels • 24/7 care.",
        "Nutritious veg & non‑veg options.",
        "Certified ingredients • Hygienic kitchens.",
      ],
      quote: "Education here goes hand in hand with care & safety.",
    },
    {
      title: "Complete Student Support System",
      points: [
        "Parent app: attendance, test scores & announcements.",
        "Mentor‑parent calls, emotional counseling & motivation.",
        "Yoga for balance & resilient mindset.",
      ],
    },
  ];

  return (
    <section id="why" className="bg-white py-1 sm:py-2">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl">Why Rankridge is Ranked Among the Top BIPC + NEET Colleges in Hyderabad</h2>
          <p className="mt-4 text-neutral-600">Confidence • Clarity • Character</p>
        </div>

        <div className="mt-4 grid gap-6 sm:grid-cols-2 lg:grid-cols-2">
          {items.map((item) => (
            <article key={item.title} className="group relative rounded-2xl bg-gradient-to-b from-white to-neutral-50 p-6 shadow-sm ring-1 ring-neutral-200 transition hover:shadow-md">
              <div className="absolute right-4 top-4 h-8 w-8 rounded-full bg-teal-600/10" />
              <h3 className="text-lg font-semibold text-neutral-900">{item.title}</h3>
              <ul className="mt-3 space-y-2 text-sm text-neutral-700">
                {item.points.map((p) => (
                  <li key={p} className="flex gap-2">
                    <span className="mt-1 inline-block h-1.5 w-1.5 flex-none rounded-full bg-teal-600" />
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
              {item.quote && (
                <p className="mt-4 rounded-xl bg-teal-50 p-3 text-sm font-medium text-teal-800">“{item.quote}”</p>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

function ValuePillars() {
  const pillars = [
    {
      title: "About Rankridge BIPC with NEET",
      desc:
        "Hyderabad’s most trusted destination for BIPC with NEET coaching. Expert faculty from AIIMS & reputed NEET academies ensure NCERT mastery and exam‑ready confidence.",
    },
    {
      title: "Proven Track Record",
      desc:
        "99% qualify NEET annually. Many secure All India Top Ranks and seats in AIIMS, JIPMER, Gandhi MC, Osmania & KMC.",
    },
    {
      title: "Holistic Care",
      desc:
        "Nutritious food, safe hostels, emotional counseling, and a digital parent dashboard. Day scholar & residential options.",
    },
  ];

  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-teal-600 to-emerald-600 py-6 sm:py-26">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,_rgba(255,255,255,0.15),_transparent_40%),_radial-gradient(circle_at_80%_30%,_rgba(255,255,255,0.12),_transparent_35%)]" />
      <div className="relative mx-auto max-w-7xl px-6">
        <div className="mx-auto grid max-w-5xl gap-6 sm:grid-cols-3">
          {pillars.map((p) => (
            <div key={p.title} className="rounded-2xl bg-white/10 p-6 text-white ring-1 ring-white/20 backdrop-blur-sm">
              <h3 className="text-lg font-semibold">{p.title}</h3>
              <p className="mt-2 text-sm text-white/90 leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Stats() {
  const stats = [
    { k: "99%", v: "NEET Qualification" },
    { k: "40", v: "Students / Class" },
    { k: "15+", v: "Years Avg Faculty Exp." },
    { k: "24/7", v: "Care in Hostels" },
  ];
  return (
    <section className="bg-white py-2">
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {stats.map((s) => (
            <div key={s.v} className="rounded-2xl bg-neutral-50 p-2 text-center shadow-sm ring-1 ring-neutral-200">
              <div className="text-3xl font-extrabold text-teal-700">{s.k}</div>
              <div className="mt-1 text-sm text-neutral-600">{s.v}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Showcase() {
  const media = [
    {
      type: "image",
      src: "https://images.unsplash.com/photo-1559757175-08c5b11e6667?q=80&w=1200&auto=format&fit=crop",
      title: "Interactive Classrooms",
    },
    {
      type: "image",
      src: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?q=80&w=1200&auto=format&fit=crop",
      title: "NEET‑Focused Labs",
    },
    {
      type: "image",
      src: "https://images.unsplash.com/photo-1596496181848-3091d4878b01?q=80&w=1200&auto=format&fit=crop",
      title: "Wellness & Yoga",
    },
    {
      type: "image",
      src: "https://images.unsplash.com/photo-1505751172876-fa1923c5c528?q=80&w=1200&auto=format&fit=crop",
      title: "Hostels & Dining",
    },
  ];

  return (
    <section className="bg-neutral-50 py-1 sm:py-2">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl">Campus & Learning Experience</h2>
          <p className="mt-3 text-neutral-600">World‑class facilities • Supportive mentors • Focused outcomes</p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {media.map((m) => (
            <figure key={m.src} className="group overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-neutral-200">
              <img src={m.src} alt={m.title} className="aspect-[4/3] w-full object-cover transition duration-300 group-hover:scale-[1.03]"/>
              <figcaption className="p-4 text-sm font-medium text-neutral-800">{m.title}</figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}

function FAQ() {
  const items = [
    {
      q: "Do you offer both day scholar and residential programs?",
      a: "Yes. Students can choose day scholar or residential. Residential students receive 24/7 care, nutritious meals, and supervised study hours.",
    },
    {
      q: "How are batches structured?",
      a: "Small batches of ~40 ensure personal attention. We conduct daily doubt‑solving, weekly mock NEET, and personalized improvement plans.",
    },
    {
      q: "What study material do students get?",
      a: "Rankridge NEET modules, NCERT‑perfect notes, DPPs, PYQs, quick‑revision cards, and illustrated summaries for retention.",
    },
    {
      q: "How can parents track progress?",
      a: "Through the Parent App—attendance, test scores, schedules, announcements—and regular mentor‑parent calls.",
    },
  ];

  return (
    <section className="bg-white py-1 sm:py-2">
      <div className="mx-auto max-w-5xl px-6">
        <h3 className="text-center text-3xl font-bold tracking-tight sm:text-4xl">FAQs</h3>
        <div className="mx-auto mt-10 divide-y divide-neutral-200 overflow-hidden rounded-2xl bg-neutral-50 shadow-sm ring-1 ring-neutral-200">
          {items.map((it, idx) => (
            <FAQItem key={idx} q={it.q} a={it.a} defaultOpen={idx === 0} />
          ))}
        </div>
      </div>
    </section>
  );
}

function FAQItem({ q, a, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div>
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left text-sm font-semibold text-neutral-900 hover:bg-white"
      >
        <span>{q}</span>
        <svg
          className={`h-5 w-5 transition-transform ${open ? "rotate-180" : "rotate-0"}`}
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M5.23 7.21a.75.75 0 011.06.02L10 11.085l3.71-3.855a.75.75 0 111.08 1.04l-4.24 4.41a.75.75 0 01-1.08 0L5.21 8.27a.75.75 0 01.02-1.06z"
            clipRule="evenodd"
          />
        </svg>
      </button>
      {open && <div className="px-5 pb-5 text-sm text-neutral-700">{a}</div>}
    </div>
  );
}

export function ContactCTA() {
  return (
    <section id="admissions" className="relative overflow-hidden bg-gradient-to-br from-neutral-900 to-neutral-800 py-16 sm:py-20">
      <div className="absolute inset-0 opacity-20" aria-hidden>
        <svg className="h-full w-full" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" viewBox="0 0 800 600">
          <defs>
            <linearGradient id="g" x1="0" x2="1">
              <stop offset="0%" stopColor="#34d399" />
              <stop offset="100%" stopColor="#06b6d4" />
            </linearGradient>
          </defs>
          <g fill="url(#g)">
            <circle cx="120" cy="120" r="90" />
            <circle cx="700" cy="160" r="70" />
            <circle cx="400" cy="520" r="110" />
          </g>
        </svg>
      </div>

      <div className="relative mx-auto max-w-7xl px-6">
        <div className="grid items-center gap-8 lg:grid-cols-2">
          <div>
            <h3 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">Join Rankridge – The Most Trusted BIPC + NEET College in Hyderabad</h3>
            <p className="mt-3 max-w-xl text-neutral-300">
              With expert faculty, proven results, world‑class facilities, and stress‑free learning, Rankridge is the No.1 choice for BIPC with NEET aspirants.
            </p>
            <ul className="mt-5 space-y-2 text-sm text-neutral-300">
              <li className="flex gap-2"><span className="mt-1 h-1.5 w-1.5 rounded-full bg-emerald-400" /> Limited Seats for 2025</li>
              <li className="flex gap-2"><span className="mt-1 h-1.5 w-1.5 rounded-full bg-emerald-400" /> Separate Boys & Girls Campuses</li>
              <li className="flex gap-2"><span className="mt-1 h-1.5 w-1.5 rounded-full bg-emerald-400" /> Day Scholar & Residential Options</li>
            </ul>
          </div>

          <div className="rounded-2xl bg-white p-6 shadow-xl ring-1 ring-neutral-200">
            <h4 className="text-lg font-semibold">Admissions Enquiry</h4>
            <p className="mt-1 text-sm text-neutral-600">Call us or submit your details. Our team will reach out shortly.</p>

            <div className="mt-4 grid gap-4 sm:grid-cols-2">
              <input className="w-full rounded-xl border border-neutral-200 bg-neutral-50 px-4 py-3 text-sm outline-none transition focus:border-teal-600 focus:bg-white" placeholder="Student Name" />
              <input className="w-full rounded-xl border border-neutral-200 bg-neutral-50 px-4 py-3 text-sm outline-none transition focus:border-teal-600 focus:bg-white" placeholder="Parent Mobile" />
              <input className="w-full rounded-xl border border-neutral-200 bg-neutral-50 px-4 py-3 text-sm outline-none transition focus:border-teal-600 focus:bg-white" placeholder="Email (optional)" />
              <select className="w-full rounded-xl border border-neutral-200 bg-neutral-50 px-4 py-3 text-sm outline-none transition focus:border-teal-600 focus:bg-white">
                <option>BIPC + NEET (2025)</option>
                <option>BIPC + NEET (2026)</option>
              </select>
              <input className="sm:col-span-2 w-full rounded-xl border border-neutral-200 bg-neutral-50 px-4 py-3 text-sm outline-none transition focus:border-teal-600 focus:bg-white" placeholder="City" />
              <textarea rows={3} className="sm:col-span-2 w-full rounded-xl border border-neutral-200 bg-neutral-50 px-4 py-3 text-sm outline-none transition focus:border-teal-600 focus:bg-white" placeholder="Tell us about the student"></textarea>
            </div>

            <div className="mt-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
              <a href="tel:+919959271353" className="inline-flex items-center justify-center rounded-xl bg-teal-600 px-5 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-teal-700">📞 Call: +91 99 59 271 353</a>
              <button className="rounded-xl border border-neutral-200 bg-neutral-900 px-5 py-3 text-sm font-semibold text-white transition hover:bg-neutral-800">Submit Enquiry</button>
            </div>

            <p className="mt-3 text-center text-xs text-neutral-500">or visit: <a href="https://www.rankridge.com/contact-us/" className="underline decoration-teal-500/50 underline-offset-2">Enquiry Now</a></p>
          </div>
        </div>
      </div>
    </section>
  );
}

function Footer() {
  return (
    <footer className="bg-white py-10">
      <div className="mx-auto max-w-7xl px-6">
        <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
          <div className="text-sm text-neutral-600">© {new Date().getFullYear()} Rankridge Junior College. All rights reserved.</div>
          <div className="flex gap-4 text-sm text-neutral-600">
            <a href="#why" className="hover:text-neutral-900">Why Rankridge</a>
            <a href="#admissions" className="hover:text-neutral-900">Admissions</a>
            <a href="#" className="hover:text-neutral-900">Privacy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
